import { render, staticRenderFns } from "./LabelCounter.vue?vue&type=template&id=9262eae2&scoped=true"
import script from "./LabelCounter.vue?vue&type=script&lang=js"
export * from "./LabelCounter.vue?vue&type=script&lang=js"
import style0 from "./LabelCounter.vue?vue&type=style&index=0&id=9262eae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9262eae2",
  null
  
)

export default component.exports